import appointmentActions from 'features/appointment/services/actions';
import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';
import { IApiGetAppointments } from 'features/appointment/services/types/api';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import moment from 'moment';
import React from 'react';
import { useAppDispatch } from 'store/hooks';
import styled from 'styled-components';
const options = [
  {
    label: 'Daily',
    value: CALENDAR_VIEW_TYPE.DAY_VIEW,
  },
  {
    label: 'Weekly',
    value: CALENDAR_VIEW_TYPE.WEEK_VIEW,
  },
  {
    label: 'Monthly',
    value: CALENDAR_VIEW_TYPE.MONTH_VIEW,
  },
];
type Props = {
  value?: CALENDAR_VIEW_TYPE;
  submitOnChange?: boolean;
  onChange?: (value: CALENDAR_VIEW_TYPE) => void;
  onSubmit?: (params: IApiGetAppointments) => void;
};
const SwitchCalendarType: React.FC<Props> = ({ value, submitOnChange, onChange: _onChange, onSubmit: _onSubmit }) => {
  const onChangeSegmented = (val: string) => {
    _onChange?.(val as CALENDAR_VIEW_TYPE);

    const now = moment();
    let params: IApiGetAppointments | null = null;
    switch (val) {
      case CALENDAR_VIEW_TYPE.DAY_VIEW: {
        params = {
          startTime: now.format(DATE_FORMAT),
          endTime: now.format(DATE_FORMAT),
        };
        break;
      }
      case CALENDAR_VIEW_TYPE.WEEK_VIEW: {
        const startTime = now.startOf('week').format(DATE_FORMAT);
        const endTime = now.endOf('week').format(DATE_FORMAT);

        params = {
          startTime,
          endTime,
        };
        break;
      }
      case CALENDAR_VIEW_TYPE.MONTH_VIEW: {
        const startTime = now.startOf('month').format(DATE_FORMAT);
        const endTime = now.endOf('month').format(DATE_FORMAT);

        params = {
          startTime,
          endTime,
        };
        break;
      }
      default:
        break;
    }

    if (params) _onSubmit?.(params);
  };

  return (
    <Container>
      {options.map((o) => (
        <button type={submitOnChange ? 'submit' : 'button'} key={o.value} className={`button ${value === o.value ? 'active' : ''}`} onClick={() => onChangeSegmented(o.value)}>
          {o.label}
        </button>
      ))}
    </Container>
  );
};

export default SwitchCalendarType;

const Container = styled.div`
  display: flex;
  border-radius: 4px;
  background: #e5e6eb;

  .button {
    height: 64px;
    padding: 0 16px;
    color: #1d2129;
    font-size: 18px;
    font-weight: 600;
    line-height: 30px;
    text-transform: capitalize;
    &.active {
      border-radius: 4px;
      background: #232f3e;
      color: #fff;
    }
  }
`;
